import actions from "../constants/dashboardActions";

export function getDashboardOverview(data) {
  return { type: actions.GET_DASHBOARD_OVERVIEW, data };
}
export function getDashboardOverviewClear(data) {
  return { type: actions.GET_DASHBOARD_OVERVIEW_CLEAR, data };
}

export function getDashboardIncomingOverview(data) {
  return { type: actions.GET_DASHBOARD_INCOMING_OVERVIEW, data };
}
export function getDashboardIncomingOverviewClear(data) {
  return { type: actions.GET_DASHBOARD_INCOMING_OVERVIEW_CLEAR, data };
}

export function getDashboardOverviewBag(data) {
  return { type: actions.GET_DASHBOARD_OVERVIEW_BAG, data };
}
export function getDashboardOverviewBagClear(data) {
  return { type: actions.GET_DASHBOARD_OVERVIEW_BAG_CLEAR, data };
}

export function getDashboardIncomingOverviewBag(data) {
  return { type: actions.GET_DASHBOARD_INCOMING_OVERVIEW_BAG, data };
}
export function getDashboardIncomingOverviewBagClear(data) {
  return { type: actions.GET_DASHBOARD_INCOMING_OVERVIEW_BAG_CLEAR, data };
}

export function getDashboardIncomingBagsClickable(data) {
  return { type: actions.GET_DASHBOARD_INCOMING_BAGS_CLICKABLE, data };
}
export function getDashboardIncomingBagsClickableClear(data) {
  return { type: actions.GET_DASHBOARD_INCOMING_BAGS_CLICKABLE_CLEAR, data };
}

export function getDashboardOutscanBagsClickable(data) {
  return { type: actions.GET_DASHBOARD_OUTSCAN_BAGS_CLICKABLE, data };
}

export function getDashboardOutscanBagsClickableClear(data) {
  return { type: actions.GET_DASHBOARD_OUTSCAN_BAGS_CLICKABLE_CLEAR, data };
}

export function getDashboardOutscanToCpShipmentsClickable(data) {
  return { type: actions.GET_DASHBOARD_OUTSCAN_TO_CP_SHIPMENTS_CLICKABLE, data };
}

export function getDashboardOutscanToCpShipmentsClickableClear(data) {
  return { type: actions.GET_DASHBOARD_OUTSCAN_TO_CP_SHIPMENTS_CLICKABLE_CLEAR, data };
}

export function getDashboardOutscanToCpBagsClickable(data) {
  return { type: actions.GET_DASHBOARD_OUTSCAN_TO_CP_BAGS_CLICKABLE, data };
}

export function getDashboardOutscanToCpBagsClickableClear(data) {
  return { type: actions.GET_DASHBOARD_OUTSCAN_TO_CP_BAGS_CLICKABLE_CLEAR, data };
}

export function getDashboardInscanShipmentsClickable(data) {
  return { type: actions.GET_DASHBOARD_INSCAN_SHIPMENTS_CLICKABLE, data };
}

export function getDashboardInscanShipmentsClickableClear(data) {
  return { type: actions.GET_DASHBOARD_INSCAN_SHIPMENTS_CLICKABLE_CLEAR, data };
}

export function getDashboardOutscanShipmentsClickable(data) {
  return { type: actions.GET_DASHBOARD_OUTSCAN_SHIPMENTS_CLICKABLE, data };
}

export function getDashboardOutscanShipmentsClickableClear(data) {
  return { type: actions.GET_DASHBOARD_OUTSCAN_SHIPMENTS_CLICKABLE_CLEAR, data };
}

export function getDashboardIncomingShipmentsClickable(data) {
  return { type: actions.GET_DASHBOARD_INCOMING_SHIPMENTS_CLICKABLE, data };
}

export function getDashboardIncomingShipmentsClickableClear(data) {
  return { type: actions.GET_DASHBOARD_INCOMING_SHIPMENTS_CLICKABLE_CLEAR, data };
}

export function getDashboardInscanBagsClickable(data) {
  return { type: actions.GET_DASHBOARD_INSCAN_BAGS_CLICKABLE, data };
}

export function getDashboardInscanBagsClickableClear(data) {
  return { type: actions.GET_DASHBOARD_INSCAN_BAGS_CLICKABLE_CLEAR, data };
}

export function getRegexPatternAction(data) {
  return { type: actions.GET_REGEX_PATTERN, data };
}

export function getRegexPatternClear(data) {
  return { type: actions.GET_REGEX_PATTERN_CLEAR, data };
}

export function getAnnouncementsAction(data) {
  return { type: actions.GET_ANNOUNCEMENTS, data };
}

export function getAnnouncementsClear(data) {
  return { type: actions.GET_ANNOUNCEMENTS_CLEAR, data };
}
